import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PosIntegrationService } from '../../../../../services/pos-integration.service';

@Component({
  selector: 'app-callback-xero',
  templateUrl: './callback-xero.component.html',
  styleUrls: ['./callback-xero.component.scss'],
})
export class CallbackXeroComponent implements OnInit {
  public broadcastChannel = new BroadcastChannel('XERO_CHANNEL');

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private posIntegrationService: PosIntegrationService,
  ) {}

  ngOnInit() {
    let PartnerID = localStorage.getItem('XeroPartnerID');
    this.activatedRoute.queryParams.subscribe((params) => {
      var data = {
        ID: parseInt(params['state']),
        PhoneNumber1: params['code'],
        PhoneNumber2: params['state'], //XERO-JC
      };
      this.posIntegrationService.registerXero(data).subscribe(
        (result) => {
          console.log(result);
          this.broadcastChannel.postMessage('CONNECTED');
          setTimeout(() => {
            window.close();
          }, 500);
        },
        (err) => {
          this.broadcastChannel.postMessage('NOT_CONNECTED');
          window.close();
        },
      );
    });
  }
}
